import userModules from './modules/user'
import navsModules from './modules/navs'

export default [
    ...userModules, 
    ...navsModules
]
